// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//DEFAULT = DEV
export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyAziQD_S0PTCncqfaD8WiaDtIN-8LWWFyw",
    authDomain: "wetter-dts-dev-207755492.firebaseapp.com",
    databaseURL: "https://wetter-dts-dev-207755492.firebaseio.com",
    projectId: "wetter-dts-dev-207755492",
    storageBucket: "wetter-dts-dev-207755492.appspot.com",
    messagingSenderId: "505725237924",
    appId: "1:505725237924:web:dfa3d7697fa340db4e0431"
  },
  storageBasePath: 'https://storage.googleapis.com/',
  // storageIconUrl: `${this.storageBasePath}${this.firebaseConfig.storageBucket}/wetter/icons/tagesschau/TSicons_`,
  // storageRadarImageUrl: `${this.storageBasePath}${this.firebaseConfig.storageBucket}/wetter/regenradar/bilder/aktuell/deutschland/`
};

